import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">页面未找到</h2>
        <p className="not-found-description">
          抱歉，您访问的页面不存在或已被移除。
        </p>
        <Link to="/" className="not-found-home-link">
          返回首页
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
